import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateOptionalTime: any;
  DateOptionalTimeRange: any;
  DateTime: any;
  Email: any;
  File: any;
  ImageFile: any;
  JSON: any;
  Mixed: any;
  VideoFile: any;
};

/**
 * The AdvertiserAccount type represents the client account of an external company that has an advertising agreement with
 * Aleph. This is almost always a company such as Wolt, Coca Cola, Trading 212, ...
 */
export type AdvertiserAccount = {
  __typename?: 'AdvertiserAccount';
  /** A subquery that shows which user groups have access to this advertiser on which apps. */
  advertiserAccountAccess?: Maybe<Array<Maybe<AdvertiserAccountAccess>>>;
  /** Datetime of when the advertiser account was created. */
  advertiserAccountCreatedAt: Scalars['DateTime'];
  advertiserAccountId: Scalars['ID'];
  /** The name of the advertiser. */
  advertiserAccountName: Scalars['String'];
  /** URL for the advertiser's profile picture. */
  advertiserAccountProfilePicture?: Maybe<Scalars['String']>;
  /** The User that owns the advertiser account. */
  owner: User;
};


/**
 * The AdvertiserAccount type represents the client account of an external company that has an advertising agreement with
 * Aleph. This is almost always a company such as Wolt, Coca Cola, Trading 212, ...
 */
export type AdvertiserAccountAdvertiserAccountAccessArgs = {
  filters?: InputMaybe<AdvertiserAccountAccessFilters>;
  orderBy?: InputMaybe<AdvertiserAccountAccessOrderBy>;
};

/**
 * The advertiserAccountAccess type represents the permission of a
 * user group to access an advertiser account on a certain app.
 */
export type AdvertiserAccountAccess = {
  __typename?: 'AdvertiserAccountAccess';
  advertiserAccount?: Maybe<AdvertiserAccount>;
  advertiserAccountAccessCreatedAt?: Maybe<Scalars['DateTime']>;
  app?: Maybe<App>;
  userGroup?: Maybe<UserGroup>;
};

export type AdvertiserAccountAccessCursored = {
  __typename?: 'AdvertiserAccountAccessCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<AdvertiserAccountAccess>>;
};

export type AdvertiserAccountAccessFilters = {
  /** Filter by advertiser account ID. */
  advertiserAccountId?: InputMaybe<Array<IdFilter>>;
  /** Filter by app ID. */
  appId?: InputMaybe<Array<IdFilter>>;
  /** Filter by user group ID. */
  userGroupId?: InputMaybe<Array<IdFilter>>;
};

export type AdvertiserAccountAccessOrderBy = {
  column: AdvertiserAccountAccessOrderByColumn;
  direction?: OrderByDirection;
};

export type AdvertiserAccountFilters = {
  /** Filter by the advertiser account's ID. */
  advertiserAccountId?: InputMaybe<Array<IdFilter>>;
  /** Filter by the advertiser account's name. */
  advertiserAccountName?: InputMaybe<Array<StringFilter>>;
  /** Filter by the user ID of the advertiser account's owner. */
  advertiserAccountOwnerId?: InputMaybe<Array<IdFilter>>;
};

export type AdvertiserAccountOrderBy = {
  column: AdvertiserAccountOrderByColumn;
  direction?: OrderByDirection;
};

export enum AdvertiserAccountOrderByColumn {
  AdvertiserAccountCreatedAt = 'advertiserAccountCreatedAt',
  AdvertiserAccountId = 'advertiserAccountId',
  AdvertiserAccountName = 'advertiserAccountName'
}

export type AdvertiserAccountsCursored = {
  __typename?: 'AdvertiserAccountsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<AdvertiserAccount>>;
};

export type App = {
  __typename?: 'App';
  advertiserAccountAccess?: Maybe<Array<AdvertiserAccountAccess>>;
  appCreatedAt: Scalars['DateTime'];
  appId: Scalars['ID'];
  appName?: Maybe<Scalars['String']>;
};


export type AppAdvertiserAccountAccessArgs = {
  filters?: InputMaybe<AdvertiserAccountAccessFilters>;
  orderBy?: InputMaybe<AdvertiserAccountAccessOrderBy>;
};

export type AppFilters = {
  appId?: InputMaybe<Array<IdFilter>>;
  appName?: InputMaybe<Array<StringFilter>>;
};

export type AppOrderBy = {
  column: AppOrderByColumn;
  direction?: OrderByDirection;
};

export enum AppOrderByColumn {
  AppCreatedAt = 'appCreatedAt',
  AppId = 'appId',
  AppName = 'appName'
}

export type AppsCursored = {
  __typename?: 'AppsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<App>>;
};

export type BooleanFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Boolean'];
};

export type BooleanRealmFilter = {
  value: Scalars['Boolean'];
};

export type Credential = {
  __typename?: 'Credential';
  credentialCreatedAt: Scalars['DateTime'];
  credentialId: Scalars['ID'];
  credentialName: Scalars['String'];
};

export type CredentialFilter = {
  credentialId?: InputMaybe<Array<IdFilter>>;
  credentialName?: InputMaybe<Array<StringFilter>>;
};

export type CredentialOrderBy = {
  column: CredentialOrderByColumn;
  direction?: OrderByDirection;
};

export enum CredentialOrderByColumn {
  CredentialCreatedAt = 'credentialCreatedAt',
  CredentialId = 'credentialId',
  CredentialName = 'credentialName'
}

export type CredentialsCursored = {
  __typename?: 'CredentialsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Credential>>;
};

export type DateFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['DateOptionalTime']>;
};

export type DateRangeFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['DateOptionalTimeRange'];
};

export type ExactStringFilter = {
  value: Scalars['String'];
};

export type FloatFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['Float']>;
};

export type IdFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['ID']>;
};

export type IdRealmFilter = {
  value: Array<Scalars['ID']>;
};

export type IntFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add a user to a user group directly. This can only be done by a platform admin. */
  addUserToUserGroup: UserGroupAccess;
  /** Assign a credential to a user. Returns a list of the user's credentials. */
  assignCredential: Array<Credential>;
  /** Assign a credentials to a user. Returns a list of the user's credentials. */
  assignCredentials: Array<Credential>;
  /**
   * Assign a credentials to a user based on the WBN platform and user role. Returns a list of the user's credentials.
   * NOTE: this endpoint should only be used on a freshly created user
   */
  assignCredentialsForWBNPlatformAndAccountRole: Array<Credential>;
  /** Create an advertiser account. */
  createAdvertiserAccount: AdvertiserAccount;
  /** Create a credential that can then be assigned to a user. */
  createCredential: Credential;
  createUser: User;
  /**  Create a new user group with a given name.  */
  createUserGroup: UserGroup;
  /** Delete a credential. Credentials that are assigned to any users cannot be deleted. */
  deleteCredential: Scalars['Boolean'];
  /**  Delete a user group.  */
  deleteUserGroup?: Maybe<Scalars['Boolean']>;
  /** Grant a user group access to an advertiser account on a specific app. */
  grantAdvertiserAccountAccess: AdvertiserAccountAccess;
  /**
   * Remove a user from a user group. This can only be done by an admin or the owner of a user group,
   * unless a user wants to remove themselves, which has no restrictions.
   * An owner cannot remove themself from a user group,
   * but must first transfer the ownership via transferUserGroupOwnership.
   */
  removeUserFromUserGroup: Scalars['Boolean'];
  /** Revoke a user group's access to an advertiser account on a specific app. */
  revokeAdvertiserAccountAccess: Scalars['Boolean'];
  /** Revoke a credential from a user. Returns a list of the user's credentials. */
  revokeCredential: Array<Credential>;
  /**
   * Make another user the new owner of a user group. The new owner must be an existing user in the user group.
   * The user making the request must be the current owner of the user group, who then becomes an admin.
   */
  transferUserGroupOwnership: UserGroupAccess;
  /** Update an existing advertiser account. Can only be done by a platform admin or the owner of the advertiser account. */
  updateAdvertiserAccount: AdvertiserAccount;
  updateMe: User;
  updateUser: User;
  /**  Update a user group.  */
  updateUserGroup: UserGroup;
  /**
   * Update a user's role in a user group. This can only be done by an admin or the owner of a user group.
   * A user can only be changed to a member or admin role.
   * The OWNER role must be transfer via the "transferUserGroupOwnership" mutation.
   */
  updateUserRoleInUserGroup: UserGroupAccess;
  version?: Maybe<Scalars['String']>;
};


export type MutationAddUserToUserGroupArgs = {
  userGroupAccessRole: UserGroupAccessRole;
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAssignCredentialArgs = {
  credentialId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAssignCredentialsArgs = {
  credentialIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationAssignCredentialsForWbnPlatformAndAccountRoleArgs = {
  WBNPlatform?: InputMaybe<WbnPlatform>;
  userId: Scalars['ID'];
};


export type MutationCreateAdvertiserAccountArgs = {
  advertiserAccountName: Scalars['String'];
  advertiserAccountOwnerId: Scalars['ID'];
  advertiserAccountProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  appId: Scalars['ID'];
};


export type MutationCreateCredentialArgs = {
  credentialName: Scalars['String'];
};


export type MutationCreateUserArgs = {
  userAccountLevel: UserAccountLevel;
  userEmail: Scalars['String'];
  userName: Scalars['String'];
  userPassword: Scalars['String'];
  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  userSurname: Scalars['String'];
};


export type MutationCreateUserGroupArgs = {
  userGroupName: Scalars['String'];
  userGroupProfilePicture?: InputMaybe<Scalars['ImageFile']>;
};


export type MutationDeleteCredentialArgs = {
  credentialId: Scalars['ID'];
};


export type MutationDeleteUserGroupArgs = {
  userGroupId: Scalars['ID'];
};


export type MutationGrantAdvertiserAccountAccessArgs = {
  advertiserAccountId: Scalars['ID'];
  appId: Scalars['ID'];
  userGroupId: Scalars['ID'];
};


export type MutationRemoveUserFromUserGroupArgs = {
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRevokeAdvertiserAccountAccessArgs = {
  advertiserAccountId: Scalars['ID'];
  appId: Scalars['ID'];
  userGroupId: Scalars['ID'];
};


export type MutationRevokeCredentialArgs = {
  credentialId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationTransferUserGroupOwnershipArgs = {
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUpdateAdvertiserAccountArgs = {
  advertiserAccountId: Scalars['ID'];
  advertiserAccountName?: InputMaybe<Scalars['String']>;
  advertiserAccountOwnerId?: InputMaybe<Scalars['ID']>;
  advertiserAccountProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  appId: Scalars['ID'];
};


export type MutationUpdateMeArgs = {
  userEmail?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  userPassword?: InputMaybe<Scalars['String']>;
  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  userSurname?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserArgs = {
  userAccountLevel?: InputMaybe<UserAccountLevel>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  userName?: InputMaybe<Scalars['String']>;
  userPassword?: InputMaybe<Scalars['String']>;
  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  userSurname?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserGroupArgs = {
  userGroupId: Scalars['ID'];
  userGroupName: Scalars['String'];
  userGroupProfilePicture?: InputMaybe<Scalars['ImageFile']>;
};


export type MutationUpdateUserRoleInUserGroupArgs = {
  userGroupAccessRole: UserGroupAccessRole;
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Query = {
  __typename?: 'Query';
  /** List advertiser account group accesses. */
  advertiserAccountAccess: AdvertiserAccountAccessCursored;
  /** A list of advertiser accounts that the user has access to. */
  advertiserAccounts: AdvertiserAccountsCursored;
  apps?: Maybe<AppsCursored>;
  credentials: CredentialsCursored;
  me: User;
  /** Get a list of accesses to user groups. */
  userGroupAccess: UserGroupAccessCursored;
  userGroups?: Maybe<UserGroupsCursored>;
  users?: Maybe<UsersCursored>;
  version?: Maybe<Scalars['String']>;
};


export type QueryAdvertiserAccountAccessArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AdvertiserAccountAccessFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdvertiserAccountAccessOrderBy>>;
};


export type QueryAdvertiserAccountsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AdvertiserAccountFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdvertiserAccountOrderBy>>;
};


export type QueryAppsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AppFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppOrderBy>>;
};


export type QueryCredentialsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CredentialFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<CredentialOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryUserGroupAccessArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<UserGroupAccessFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserGroupAccessOrderBy>>;
};


export type QueryUserGroupsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<UserGroupFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserGroupOrderBy>>;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<UserFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOrderBy>>;
};

export type SingleDateFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['DateOptionalTime'];
};

export type SingleDateRealmFilter = {
  value: Scalars['DateTime'];
};

export type SingleFloatFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Float'];
};

export type SingleFloatRealmFilter = {
  value: Scalars['Float'];
};

export type SingleIdFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['ID'];
};

export type SingleIdRealmFilter = {
  value: Scalars['ID'];
};

export type SingleIntFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Int'];
};

export type SingleIntRealmFilter = {
  value: Scalars['Int'];
};

export type SingleStringFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
  wildcard?: InputMaybe<Scalars['Boolean']>;
};

export type SingleStringRealmFilter = {
  value: Scalars['String'];
};

export type StringFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['String']>;
  wildcard?: InputMaybe<Scalars['Boolean']>;
};

export type StringRealmFilter = {
  value: Array<Scalars['String']>;
};

/** A user represents a person that can authenticate with the global auth system. */
export type User = {
  __typename?: 'User';
  credentials?: Maybe<Array<Credential>>;
  userAccountLevel: UserAccountLevel;
  userCreatedAt: Scalars['DateTime'];
  userEmail: Scalars['String'];
  userGroupAccess?: Maybe<Array<UserGroupAccess>>;
  userId: Scalars['ID'];
  userName: Scalars['String'];
  userProfilePictureUrl?: Maybe<Scalars['String']>;
  userSurname: Scalars['String'];
  userTwoFactorAuthenticationEnabled: Scalars['Boolean'];
};


/** A user represents a person that can authenticate with the global auth system. */
export type UserCredentialsArgs = {
  filters?: InputMaybe<CredentialFilter>;
  orderBy?: InputMaybe<Array<CredentialOrderBy>>;
};


/** A user represents a person that can authenticate with the global auth system. */
export type UserUserGroupAccessArgs = {
  filters?: InputMaybe<UserGroupAccessFilters>;
  orderBy?: InputMaybe<Array<UserGroupAccessOrderBy>>;
};

export enum UserAccountLevel {
  AdvertiserAdmin = 'ADVERTISER_ADMIN',
  AgencyAdmin = 'AGENCY_ADMIN',
  PlatformAdmin = 'PLATFORM_ADMIN',
  User = 'USER'
}

export type UserAccountLevelFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: UserAccountLevel;
};

export type UserFilters = {
  userAccountLevel?: InputMaybe<Array<UserAccountLevelFilter>>;
  userEmail?: InputMaybe<Array<StringFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
  userName?: InputMaybe<Array<StringFilter>>;
  userSurname?: InputMaybe<Array<StringFilter>>;
  userTwoFactorAuthenticationEnabled?: InputMaybe<Array<BooleanFilter>>;
};

/** A user group is a collection of users. It may also be one user. */
export type UserGroup = {
  __typename?: 'UserGroup';
  /**  A subquery for all advertiser accounts that the user group has access to, and on which app.  */
  advertiserAccountAccess?: Maybe<Array<AdvertiserAccountAccess>>;
  /**  A subquery for all users that have access to the user group, and at which level.  */
  userGroupAccess?: Maybe<Array<Maybe<UserGroupAccess>>>;
  /**  The date and time the user group was created at.  */
  userGroupCreatedAt: Scalars['DateTime'];
  /**  The ID of the user group.  */
  userGroupId: Scalars['ID'];
  /**  The name of the user group.  */
  userGroupName: Scalars['String'];
  /**  The type of the user group.  */
  userGroupType: UserGroupType;
};


/** A user group is a collection of users. It may also be one user. */
export type UserGroupAdvertiserAccountAccessArgs = {
  filters?: InputMaybe<AdvertiserAccountAccessFilters>;
  orderBy?: InputMaybe<Array<InputMaybe<AdvertiserAccountAccessOrderBy>>>;
};


/** A user group is a collection of users. It may also be one user. */
export type UserGroupUserGroupAccessArgs = {
  filters?: InputMaybe<UserGroupAccessFilters>;
  orderBy?: InputMaybe<Array<UserGroupAccessOrderBy>>;
};

export type UserGroupAccess = {
  __typename?: 'UserGroupAccess';
  /** The user that has access. */
  user: User;
  /** The user group that the user has access to. */
  userGroup?: Maybe<UserGroup>;
  /** The time that the access was first granted. */
  userGroupAccessCreatedAt: Scalars['DateTime'];
  /** The user's role in the user group. */
  userGroupAccessRole: UserGroupAccessRole;
};

export type UserGroupAccessCursored = {
  __typename?: 'UserGroupAccessCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<UserGroupAccess>>;
};

export type UserGroupAccessFilters = {
  userGroupAccessRole?: InputMaybe<Array<UserGroupAccessRoleFilter>>;
  userGroupId?: InputMaybe<Array<IdFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
};

export type UserGroupAccessOrderBy = {
  column: UserGroupAccessOrderByColumn;
  direction?: OrderByDirection;
};

export enum UserGroupAccessOrderByColumn {
  UserGroupAccessCreatedAt = 'userGroupAccessCreatedAt',
  UserGroupAccessRole = 'userGroupAccessRole'
}

/** Represents the role that a user has in a user group. */
export enum UserGroupAccessRole {
  /** An admin of a user group, granting them special administrative privileges. */
  Admin = 'ADMIN',
  /** A member of a user group. */
  Member = 'MEMBER',
  /** The owner of a user group. Only one can exist at any moment. */
  Owner = 'OWNER'
}

export type UserGroupAccessRoleFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<UserGroupAccessRole>;
};

export type UserGroupFilter = {
  userGroupId?: InputMaybe<Array<IdFilter>>;
  userGroupName?: InputMaybe<Array<StringFilter>>;
  userGroupOwnerEmail?: InputMaybe<Array<StringFilter>>;
  userGroupType?: InputMaybe<Array<UserGroupTypeFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
};

export type UserGroupOrderBy = {
  column: UserGroupOrderByColumn;
  direction?: OrderByDirection;
};

export enum UserGroupOrderByColumn {
  UserGroupCreatedAt = 'userGroupCreatedAt',
  UserGroupId = 'userGroupId',
  UserGroupName = 'userGroupName',
  UserGroupType = 'userGroupType'
}

export enum UserGroupType {
  /**  A PRIVATE user group belongs to, and contains, only one user.  */
  Private = 'PRIVATE',
  /**  A PUBLIC user group contains multiple users.  */
  Public = 'PUBLIC'
}

export type UserGroupTypeFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<UserGroupType>;
};

export type UserGroupsCursored = {
  __typename?: 'UserGroupsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<UserGroup>>;
};

export type UserOrderBy = {
  column: UserOrderByColumn;
  direction?: OrderByDirection;
};

export enum UserOrderByColumn {
  UserAccountLevel = 'userAccountLevel',
  UserCreatedAt = 'userCreatedAt',
  UserEmail = 'userEmail',
  UserId = 'userId',
  UserName = 'userName',
  UserSurname = 'userSurname',
  UserTwoFactorAuthenticationEnabled = 'userTwoFactorAuthenticationEnabled'
}

export type UsersCursored = {
  __typename?: 'UsersCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<User>>;
};

export enum WbnPlatform {
  Facebook = 'FACEBOOK',
  Reddit = 'REDDIT',
  Spotify = 'SPOTIFY',
  Tiktok = 'TIKTOK',
  X = 'X'
}

export enum AdvertiserAccountAccessOrderByColumn {
  AdvertiserAccountAccessCreatedAt = 'advertiserAccountAccessCreatedAt'
}



export type AuthGraphAddUserToUserGroupMutationVariables = Exact<{

  userId: Scalars['ID'];

  userGroupId: Scalars['ID'];

}>;

export type AuthGraphAddUserToUserGroupMutationUser = {
	__typename?: 'User',
	userId: string,
	userEmail: string,
	userName: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel 
}

export type AuthGraphAddUserToUserGroupMutationUserUser = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userSurname: string,
	userEmail: string,
	id: string 
}

export type AuthGraphAddUserToUserGroupMutationUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphAddUserToUserGroupMutationUserUser 
}

export type AuthGraphAddUserToUserGroupMutationUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	userGroupCreatedAt: any,
	id: string,
	value: string,
	label: string,
	userGroupAccess?: Array<AuthGraphAddUserToUserGroupMutationUserGroupAccess | null> | null 
}

export type AuthGraphAddUserToUserGroupMutationAddUserToUserGroup = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	userGroupAccessCreatedAt: any,
	user: AuthGraphAddUserToUserGroupMutationUser, userGroup?: AuthGraphAddUserToUserGroupMutationUserGroup | null 
}

export type AuthGraphAddUserToUserGroupMutation = {
	__typename?: 'Mutation',
	addUserToUserGroup: AuthGraphAddUserToUserGroupMutationAddUserToUserGroup 
};

export type AuthGraphAdvertiserQueryVariables = Exact<{

  advertiserId: Scalars['ID'];

}>;

export type AuthGraphAdvertiserQueryOwner = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userEmail: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	id: string 
}

export type AuthGraphAdvertiserQueryAdvertiserAccount = {
	__typename?: 'AdvertiserAccount',
	advertiserAccountId: string,
	advertiserAccountName: string,
	owner: AuthGraphAdvertiserQueryOwner 
}

export type AuthGraphAdvertiserQueryUser = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userEmail: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	id: string 
}

export type AuthGraphAdvertiserQueryUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphAdvertiserQueryUser 
}

export type AuthGraphAdvertiserQueryUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupAccess?: Array<AuthGraphAdvertiserQueryUserGroupAccess | null> | null 
}

export type AuthGraphAdvertiserQueryAdvertiserAccountAccess = {
	__typename?: 'AdvertiserAccountAccess',
	advertiserAccount?: AuthGraphAdvertiserQueryAdvertiserAccount | null,
	userGroup?: AuthGraphAdvertiserQueryUserGroup | null 
}

export type AuthGraphAdvertiserQueryItems = {
	__typename?: 'AdvertiserAccount',
	id: string,
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountCreatedAt: any,
	owner: AuthGraphAdvertiserQueryOwner, advertiserAccountAccess?: Array<AuthGraphAdvertiserQueryAdvertiserAccountAccess | null> | null 
}

export type AuthGraphAdvertiserQueryAdvertiserAccounts = {
	__typename?: 'AdvertiserAccountsCursored',
	cursor?: string | null,
	items?: Array<AuthGraphAdvertiserQueryItems> | null 
}

export type AuthGraphAdvertiserQuery = {
	__typename?: 'Query',
	advertiserAccounts: AuthGraphAdvertiserQueryAdvertiserAccounts 
};

export type AuthGraphAccountAccessOptionsQueryVariables = Exact<{

  search: Scalars['String'];

  selectedGroupIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type AuthGraphAccountAccessOptionsQueryUser = {
	__typename?: 'User',
	userId: string,
	userEmail: string 
}

export type AuthGraphAccountAccessOptionsQueryUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphAccountAccessOptionsQueryUser 
}

export type AuthGraphAccountAccessOptionsQueryItems = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	label: string,
	value: string,
	userGroupAccess?: Array<AuthGraphAccountAccessOptionsQueryUserGroupAccess | null> | null 
}

export type AuthGraphAccountAccessOptionsQueryUserGroups = {
	__typename?: 'UserGroupsCursored',
	cursor?: string | null,
	items?: Array<AuthGraphAccountAccessOptionsQueryItems> | null 
}

export type AuthGraphAccountAccessOptionsQueryUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	label: string,
	value: string 
}

export type AuthGraphAccountAccessOptionsQueryUserGroupAccessUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	userGroup?: AuthGraphAccountAccessOptionsQueryUserGroup | null,
	user: AuthGraphAccountAccessOptionsQueryUser 
}

export type AuthGraphAccountAccessOptionsQueryItemsItems = {
	__typename?: 'User',
	userId: string,
	userEmail: string,
	userName: string,
	userSurname: string,
	userProfilePictureUrl?: string | null,
	id: string,
	userGroupAccess?: Array<AuthGraphAccountAccessOptionsQueryUserGroupAccessUserGroupAccess> | null 
}

export type AuthGraphAccountAccessOptionsQueryUsers = {
	__typename?: 'UsersCursored',
	cursor?: string | null,
	items?: Array<AuthGraphAccountAccessOptionsQueryItemsItems> | null 
}

export type AuthGraphAccountAccessOptionsQuery = {
	__typename?: 'Query',
	userGroups?: AuthGraphAccountAccessOptionsQueryUserGroups | null,
	users?: AuthGraphAccountAccessOptionsQueryUsers | null 
};

export type AuthGraphAdvertiserListQueryVariables = Exact<{

  search: Scalars['String'];

  cursor?: InputMaybe<Scalars['String']>;

}>;

export type AuthGraphAdvertiserListQueryOwner = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userEmail: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	id: string 
}

export type AuthGraphAdvertiserListQueryUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string 
}

export type AuthGraphAdvertiserListQueryAdvertiserAccountAccess = {
	__typename?: 'AdvertiserAccountAccess',
	userGroup?: AuthGraphAdvertiserListQueryUserGroup | null 
}

export type AuthGraphAdvertiserListQueryItems = {
	__typename?: 'AdvertiserAccount',
	id: string,
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountCreatedAt: any,
	owner: AuthGraphAdvertiserListQueryOwner, advertiserAccountAccess?: Array<AuthGraphAdvertiserListQueryAdvertiserAccountAccess | null> | null 
}

export type AuthGraphAdvertiserListQueryAdvertiserAccounts = {
	__typename?: 'AdvertiserAccountsCursored',
	cursor?: string | null,
	items?: Array<AuthGraphAdvertiserListQueryItems> | null 
}

export type AuthGraphAdvertiserListQuery = {
	__typename?: 'Query',
	advertiserAccounts: AuthGraphAdvertiserListQueryAdvertiserAccounts 
};

export type AuthGraphCreateAdvertiserMutationVariables = Exact<{

  advertiserAccountName: Scalars['String'];

  advertiserAccountOwnerId: Scalars['ID'];

  appId: Scalars['ID'];

}>;

export type AuthGraphCreateAdvertiserMutationOwner = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userEmail: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	id: string 
}

export type AuthGraphCreateAdvertiserMutationAdvertiserAccount = {
	__typename?: 'AdvertiserAccount',
	advertiserAccountId: string,
	advertiserAccountName: string,
	owner: AuthGraphCreateAdvertiserMutationOwner 
}

export type AuthGraphCreateAdvertiserMutationUser = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userEmail: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	id: string 
}

export type AuthGraphCreateAdvertiserMutationUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphCreateAdvertiserMutationUser 
}

export type AuthGraphCreateAdvertiserMutationUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupAccess?: Array<AuthGraphCreateAdvertiserMutationUserGroupAccess | null> | null 
}

export type AuthGraphCreateAdvertiserMutationAdvertiserAccountAccess = {
	__typename?: 'AdvertiserAccountAccess',
	advertiserAccount?: AuthGraphCreateAdvertiserMutationAdvertiserAccount | null,
	userGroup?: AuthGraphCreateAdvertiserMutationUserGroup | null 
}

export type AuthGraphCreateAdvertiserMutationCreateAdvertiserAccount = {
	__typename?: 'AdvertiserAccount',
	id: string,
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountCreatedAt: any,
	owner: AuthGraphCreateAdvertiserMutationOwner, advertiserAccountAccess?: Array<AuthGraphCreateAdvertiserMutationAdvertiserAccountAccess | null> | null 
}

export type AuthGraphCreateAdvertiserMutation = {
	__typename?: 'Mutation',
	createAdvertiserAccount: AuthGraphCreateAdvertiserMutationCreateAdvertiserAccount 
};

export type AuthGraphCreateUserMutationVariables = Exact<{

  userEmail: Scalars['String'];

  userPassword: Scalars['String'];

  userName: Scalars['String'];

  userSurname: Scalars['String'];

  userAccountLevel: UserAccountLevel;

}>;

export type AuthGraphCreateUserMutationAdvertiserAccount = {
	__typename?: 'AdvertiserAccount',
	advertiserAccountId: string,
	advertiserAccountName: string 
}

export type AuthGraphCreateUserMutationAdvertiserAccountAccess = {
	__typename?: 'AdvertiserAccountAccess',
	advertiserAccount?: AuthGraphCreateUserMutationAdvertiserAccount | null 
}

export type AuthGraphCreateUserMutationUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	id: string,
	value: string,
	label: string,
	advertiserAccountAccess?: Array<AuthGraphCreateUserMutationAdvertiserAccountAccess> | null 
}

export type AuthGraphCreateUserMutationUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	userGroup?: AuthGraphCreateUserMutationUserGroup | null 
}

export type AuthGraphCreateUserMutationCreateUser = {
	__typename?: 'User',
	userId: string,
	userEmail: string,
	userName: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	userTwoFactorAuthenticationEnabled: boolean,
	userCreatedAt: any,
	id: string,
	userGroupAccess?: Array<AuthGraphCreateUserMutationUserGroupAccess> | null 
}

export type AuthGraphCreateUserMutation = {
	__typename?: 'Mutation',
	createUser: AuthGraphCreateUserMutationCreateUser 
};

export type AuthGraphCreateUserGroupMutationVariables = Exact<{

  userGroupName: Scalars['String'];

}>;

export type AuthGraphCreateUserGroupMutationUser = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userSurname: string,
	userEmail: string,
	id: string 
}

export type AuthGraphCreateUserGroupMutationUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphCreateUserGroupMutationUser 
}

export type AuthGraphCreateUserGroupMutationAdvertiserAccount = {
	__typename?: 'AdvertiserAccount',
	advertiserAccountId: string,
	advertiserAccountName: string,
	id: string,
	agencyAccountId: string,
	agencyAccountName: string 
}

export type AuthGraphCreateUserGroupMutationAdvertiserAccountAccess = {
	__typename?: 'AdvertiserAccountAccess',
	advertiserAccount?: AuthGraphCreateUserGroupMutationAdvertiserAccount | null 
}

export type AuthGraphCreateUserGroupMutationCreateUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	userGroupCreatedAt: any,
	id: string,
	userGroupAccess?: Array<AuthGraphCreateUserGroupMutationUserGroupAccess | null> | null,
	advertiserAccountAccess?: Array<AuthGraphCreateUserGroupMutationAdvertiserAccountAccess> | null 
}

export type AuthGraphCreateUserGroupMutation = {
	__typename?: 'Mutation',
	createUserGroup: AuthGraphCreateUserGroupMutationCreateUserGroup 
};

export type AuthGraphDeleteUserGroupMutationVariables = Exact<{

  userGroupId: Scalars['ID'];

}>;

export type AuthGraphDeleteUserGroupMutation = {
	__typename?: 'Mutation',
	deleteUserGroup?: boolean | null 
};

export type AuthGraphAdvertiserOwnersQueryVariables = Exact<{

  advertiserId: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type AuthGraphAdvertiserOwnersQueryOwner = {
	__typename?: 'User',
	id: string 
}

export type AuthGraphAdvertiserOwnersQueryItems = {
	__typename?: 'AdvertiserAccount',
	owner: AuthGraphAdvertiserOwnersQueryOwner 
}

export type AuthGraphAdvertiserOwnersQueryAdvertiserAccounts = {
	__typename?: 'AdvertiserAccountsCursored',
	cursor?: string | null,
	items?: Array<AuthGraphAdvertiserOwnersQueryItems> | null 
}

export type AuthGraphAdvertiserOwnersQuery = {
	__typename?: 'Query',
	advertiserAccounts: AuthGraphAdvertiserOwnersQueryAdvertiserAccounts 
};

export type AuthGraphGrantAdvertiserAccountAccessMutationVariables = Exact<{

  userGroupId: Scalars['ID'];

  advertiserAccountId: Scalars['ID'];

  appId: Scalars['ID'];

}>;

export type AuthGraphGrantAdvertiserAccountAccessMutationUser = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userEmail: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	id: string 
}

export type AuthGraphGrantAdvertiserAccountAccessMutationUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphGrantAdvertiserAccountAccessMutationUser 
}

export type AuthGraphGrantAdvertiserAccountAccessMutationUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupAccess?: Array<AuthGraphGrantAdvertiserAccountAccessMutationUserGroupAccess | null> | null 
}

export type AuthGraphGrantAdvertiserAccountAccessMutationGrantAdvertiserAccountAccess = {
	__typename?: 'AdvertiserAccountAccess',
	userGroup?: AuthGraphGrantAdvertiserAccountAccessMutationUserGroup | null 
}

export type AuthGraphGrantAdvertiserAccountAccessMutation = {
	__typename?: 'Mutation',
	grantAdvertiserAccountAccess: AuthGraphGrantAdvertiserAccountAccessMutationGrantAdvertiserAccountAccess 
};

export type AuthGraphGetUserGroupsAccessQueryVariables = Exact<{

  userIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type AuthGraphGetUserGroupsAccessQueryItems = {
	__typename?: 'UserGroup',
	userGroupId: string 
}

export type AuthGraphGetUserGroupsAccessQueryUserGroups = {
	__typename?: 'UserGroupsCursored',
	cursor?: string | null,
	items?: Array<AuthGraphGetUserGroupsAccessQueryItems> | null 
}

export type AuthGraphGetUserGroupsAccessQuery = {
	__typename?: 'Query',
	userGroups?: AuthGraphGetUserGroupsAccessQueryUserGroups | null 
};

export type AuthGraphRevokeAdvertiserAccountAccessMutationVariables = Exact<{

  userGroupId: Scalars['ID'];

  advertiserAccountId: Scalars['ID'];

  appId: Scalars['ID'];

}>;

export type AuthGraphRevokeAdvertiserAccountAccessMutation = {
	__typename?: 'Mutation',
	revokeAdvertiserAccountAccess: boolean 
};

export type AuthGraphRevokeUserFromGroupMutationVariables = Exact<{

  userId: Scalars['ID'];

  userGroupId: Scalars['ID'];

}>;

export type AuthGraphRevokeUserFromGroupMutation = {
	__typename?: 'Mutation',
	removeUserFromUserGroup: boolean 
};

export type AuthGraphSearchOwnerQueryVariables = Exact<{

  search: Scalars['String'];

}>;

export type AuthGraphSearchOwnerQueryItems = {
	__typename?: 'User',
	userId: string,
	userEmail: string,
	userName: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	userProfilePictureUrl?: string | null,
	userTwoFactorAuthenticationEnabled: boolean,
	userCreatedAt: any,
	id: string 
}

export type AuthGraphSearchOwnerQueryUsers = {
	__typename?: 'UsersCursored',
	cursor?: string | null,
	items?: Array<AuthGraphSearchOwnerQueryItems> | null 
}

export type AuthGraphSearchOwnerQuery = {
	__typename?: 'Query',
	users?: AuthGraphSearchOwnerQueryUsers | null 
};

export type AuthGraphReportSharingOptionsQueryVariables = Exact<{

  userGroupOwnerEmail: Scalars['String'];

}>;

export type AuthGraphReportSharingOptionsQueryItems = {
	__typename?: 'UserGroup',
	name: string,
	id: string 
}

export type AuthGraphReportSharingOptionsQueryPrivateGroups = {
	__typename?: 'UserGroupsCursored',
	items?: Array<AuthGraphReportSharingOptionsQueryItems> | null 
}

export type AuthGraphReportSharingOptionsQueryPublicGroups = {
	__typename?: 'UserGroupsCursored',
	items?: Array<AuthGraphReportSharingOptionsQueryItems> | null 
}

export type AuthGraphReportSharingOptionsQuery = {
	__typename?: 'Query',
	privateGroups?: AuthGraphReportSharingOptionsQueryPrivateGroups | null,
	publicGroups?: AuthGraphReportSharingOptionsQueryPublicGroups | null 
};

export type AuthGraphTransferGroupOwnershipMutationVariables = Exact<{

  userGroupId: Scalars['ID'];

  userId: Scalars['ID'];

}>;

export type AuthGraphTransferGroupOwnershipMutationUser = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userSurname: string,
	userEmail: string,
	id: string 
}

export type AuthGraphTransferGroupOwnershipMutationUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphTransferGroupOwnershipMutationUser 
}

export type AuthGraphTransferGroupOwnershipMutationUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	userGroupAccess?: Array<AuthGraphTransferGroupOwnershipMutationUserGroupAccess | null> | null 
}

export type AuthGraphTransferGroupOwnershipMutationTransferUserGroupOwnership = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	userGroup?: AuthGraphTransferGroupOwnershipMutationUserGroup | null 
}

export type AuthGraphTransferGroupOwnershipMutation = {
	__typename?: 'Mutation',
	transferUserGroupOwnership: AuthGraphTransferGroupOwnershipMutationTransferUserGroupOwnership 
};

export type AuthGraphUpdateAdvertiserAccountMutationVariables = Exact<{

  advertiserAccountId: Scalars['ID'];

  advertiserAccountName?: InputMaybe<Scalars['String']>;

  advertiserAccountOwnerId?: InputMaybe<Scalars['ID']>;

  appId: Scalars['ID'];

}>;

export type AuthGraphUpdateAdvertiserAccountMutationOwner = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userEmail: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	id: string 
}

export type AuthGraphUpdateAdvertiserAccountMutationAdvertiserAccount = {
	__typename?: 'AdvertiserAccount',
	advertiserAccountId: string,
	advertiserAccountName: string,
	owner: AuthGraphUpdateAdvertiserAccountMutationOwner 
}

export type AuthGraphUpdateAdvertiserAccountMutationUser = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userEmail: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	id: string 
}

export type AuthGraphUpdateAdvertiserAccountMutationUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphUpdateAdvertiserAccountMutationUser 
}

export type AuthGraphUpdateAdvertiserAccountMutationUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupAccess?: Array<AuthGraphUpdateAdvertiserAccountMutationUserGroupAccess | null> | null 
}

export type AuthGraphUpdateAdvertiserAccountMutationAdvertiserAccountAccess = {
	__typename?: 'AdvertiserAccountAccess',
	advertiserAccount?: AuthGraphUpdateAdvertiserAccountMutationAdvertiserAccount | null,
	userGroup?: AuthGraphUpdateAdvertiserAccountMutationUserGroup | null 
}

export type AuthGraphUpdateAdvertiserAccountMutationUpdateAdvertiserAccount = {
	__typename?: 'AdvertiserAccount',
	id: string,
	agencyAccountId: string,
	agencyAccountName: string,
	agencyAccountCreatedAt: any,
	owner: AuthGraphUpdateAdvertiserAccountMutationOwner, advertiserAccountAccess?: Array<AuthGraphUpdateAdvertiserAccountMutationAdvertiserAccountAccess | null> | null 
}

export type AuthGraphUpdateAdvertiserAccountMutation = {
	__typename?: 'Mutation',
	updateAdvertiserAccount: AuthGraphUpdateAdvertiserAccountMutationUpdateAdvertiserAccount 
};

export type AuthGraphUpdateUserMutationVariables = Exact<{

  userId: Scalars['ID'];

  userEmail?: InputMaybe<Scalars['String']>;

  userPassword?: InputMaybe<Scalars['String']>;

  userName?: InputMaybe<Scalars['String']>;

  userSurname?: InputMaybe<Scalars['String']>;

  userAccountLevel?: InputMaybe<UserAccountLevel>;

}>;

export type AuthGraphUpdateUserMutationCredentials = {
	__typename?: 'Credential',
	credentialId: string,
	credentialName: string 
}

export type AuthGraphUpdateUserMutationUser = {
	__typename?: 'User',
	userName: string 
}

export type AuthGraphUpdateUserMutationUserGroup = {
	__typename?: 'UserGroup',
	userGroupName: string 
}

export type AuthGraphUpdateUserMutationUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	userGroupAccessCreatedAt: any,
	user: AuthGraphUpdateUserMutationUser, userGroup?: AuthGraphUpdateUserMutationUserGroup | null 
}

export type AuthGraphUpdateUserMutationUpdateUser = {
	__typename?: 'User',
	userId: string,
	userEmail: string,
	userName: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	userProfilePictureUrl?: string | null,
	userTwoFactorAuthenticationEnabled: boolean,
	userCreatedAt: any,
	id: string,
	credentials?: Array<AuthGraphUpdateUserMutationCredentials> | null,
	userGroupAccess?: Array<AuthGraphUpdateUserMutationUserGroupAccess> | null 
}

export type AuthGraphUpdateUserMutation = {
	__typename?: 'Mutation',
	updateUser: AuthGraphUpdateUserMutationUpdateUser 
};

export type AuthGraphUpdateUserGroupMutationVariables = Exact<{

  userGroupId: Scalars['ID'];

  userGroupName: Scalars['String'];

}>;

export type AuthGraphUpdateUserGroupMutationUser = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userSurname: string,
	userEmail: string,
	id: string 
}

export type AuthGraphUpdateUserGroupMutationUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphUpdateUserGroupMutationUser 
}

export type AuthGraphUpdateUserGroupMutationAdvertiserAccount = {
	__typename?: 'AdvertiserAccount',
	advertiserAccountId: string,
	advertiserAccountName: string,
	id: string,
	agencyAccountId: string,
	agencyAccountName: string 
}

export type AuthGraphUpdateUserGroupMutationAdvertiserAccountAccess = {
	__typename?: 'AdvertiserAccountAccess',
	advertiserAccount?: AuthGraphUpdateUserGroupMutationAdvertiserAccount | null 
}

export type AuthGraphUpdateUserGroupMutationUpdateUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	userGroupCreatedAt: any,
	id: string,
	userGroupAccess?: Array<AuthGraphUpdateUserGroupMutationUserGroupAccess | null> | null,
	advertiserAccountAccess?: Array<AuthGraphUpdateUserGroupMutationAdvertiserAccountAccess> | null 
}

export type AuthGraphUpdateUserGroupMutation = {
	__typename?: 'Mutation',
	updateUserGroup: AuthGraphUpdateUserGroupMutationUpdateUserGroup 
};

export type AuthGraphUpdateUserRoleInUserGroupMutationVariables = Exact<{

  userId: Scalars['ID'];

  userGroupId: Scalars['ID'];

  userGroupAccessRole: UserGroupAccessRole;

}>;

export type AuthGraphUpdateUserRoleInUserGroupMutationUser = {
	__typename?: 'User',
	userId: string,
	userEmail: string,
	userName: string,
	userSurname: string 
}

export type AuthGraphUpdateUserRoleInUserGroupMutationUpdateUserRoleInUserGroup = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphUpdateUserRoleInUserGroupMutationUser 
}

export type AuthGraphUpdateUserRoleInUserGroupMutation = {
	__typename?: 'Mutation',
	updateUserRoleInUserGroup: AuthGraphUpdateUserRoleInUserGroupMutationUpdateUserRoleInUserGroup 
};

export type AuthGraphUserGroupsListQueryVariables = Exact<{

  search: Scalars['String'];

  cursor?: InputMaybe<Scalars['String']>;

}>;

export type AuthGraphUserGroupsListQueryUser = {
	__typename?: 'User',
	userId: string,
	userName: string,
	userSurname: string,
	userEmail: string,
	id: string 
}

export type AuthGraphUserGroupsListQueryUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphUserGroupsListQueryUser 
}

export type AuthGraphUserGroupsListQueryAdvertiserAccount = {
	__typename?: 'AdvertiserAccount',
	advertiserAccountId: string,
	advertiserAccountName: string,
	id: string,
	agencyAccountId: string,
	agencyAccountName: string 
}

export type AuthGraphUserGroupsListQueryAdvertiserAccountAccess = {
	__typename?: 'AdvertiserAccountAccess',
	advertiserAccount?: AuthGraphUserGroupsListQueryAdvertiserAccount | null 
}

export type AuthGraphUserGroupsListQueryItems = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	userGroupCreatedAt: any,
	id: string,
	userGroupAccess?: Array<AuthGraphUserGroupsListQueryUserGroupAccess | null> | null,
	advertiserAccountAccess?: Array<AuthGraphUserGroupsListQueryAdvertiserAccountAccess> | null 
}

export type AuthGraphUserGroupsListQueryUserGroups = {
	__typename?: 'UserGroupsCursored',
	cursor?: string | null,
	items?: Array<AuthGraphUserGroupsListQueryItems> | null 
}

export type AuthGraphUserGroupsListQuery = {
	__typename?: 'Query',
	userGroups?: AuthGraphUserGroupsListQueryUserGroups | null 
};

export type AuthGraphUsersListQueryVariables = Exact<{

  search: Scalars['String'];

  email: Scalars['String'];

  cursor?: InputMaybe<Scalars['String']>;

}>;

export type AuthGraphUsersListQueryCredentials = {
	__typename?: 'Credential',
	credentialId: string,
	credentialName: string 
}

export type AuthGraphUsersListQueryAdvertiserAccount = {
	__typename?: 'AdvertiserAccount',
	advertiserAccountId: string,
	advertiserAccountName: string 
}

export type AuthGraphUsersListQueryAdvertiserAccountAccess = {
	__typename?: 'AdvertiserAccountAccess',
	advertiserAccount?: AuthGraphUsersListQueryAdvertiserAccount | null 
}

export type AuthGraphUsersListQueryUserGroup = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	userGroupType: UserGroupType,
	id: string,
	value: string,
	label: string,
	advertiserAccountAccess?: Array<AuthGraphUsersListQueryAdvertiserAccountAccess> | null 
}

export type AuthGraphUsersListQueryUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	userGroup?: AuthGraphUsersListQueryUserGroup | null 
}

export type AuthGraphUsersListQueryItems = {
	__typename?: 'User',
	userId: string,
	userEmail: string,
	userName: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	userProfilePictureUrl?: string | null,
	userTwoFactorAuthenticationEnabled: boolean,
	userCreatedAt: any,
	id: string,
	credentials?: Array<AuthGraphUsersListQueryCredentials> | null,
	userGroupAccess?: Array<AuthGraphUsersListQueryUserGroupAccess> | null 
}

export type AuthGraphUsersListQueryUsers = {
	__typename?: 'UsersCursored',
	cursor?: string | null,
	items?: Array<AuthGraphUsersListQueryItems> | null 
}

export type AuthGraphUsersListQuery = {
	__typename?: 'Query',
	users?: AuthGraphUsersListQueryUsers | null 
};

export type AuthGraphSpotifyReportDataSourcesQueryVariables = Exact<{

  userGroupName: Scalars['String'];

}>;

export type AuthGraphSpotifyReportDataSourcesQueryItems = {
	__typename?: 'UserGroup',
	name: string,
	id: string 
}

export type AuthGraphSpotifyReportDataSourcesQueryUserGroups = {
	__typename?: 'UserGroupsCursored',
	items?: Array<AuthGraphSpotifyReportDataSourcesQueryItems> | null 
}

export type AuthGraphSpotifyReportDataSourcesQuery = {
	__typename?: 'Query',
	userGroups?: AuthGraphSpotifyReportDataSourcesQueryUserGroups | null 
};

export type AuthGraphSpotifyReportExistingGroupsQueryVariables = Exact<{

  userGroupId: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type AuthGraphSpotifyReportExistingGroupsQueryItems = {
	__typename?: 'UserGroup',
	name: string,
	id: string 
}

export type AuthGraphSpotifyReportExistingGroupsQueryUserGroups = {
	__typename?: 'UserGroupsCursored',
	items?: Array<AuthGraphSpotifyReportExistingGroupsQueryItems> | null 
}

export type AuthGraphSpotifyReportExistingGroupsQuery = {
	__typename?: 'Query',
	userGroups?: AuthGraphSpotifyReportExistingGroupsQueryUserGroups | null 
};

export type AuthGraphUserGroupsOptionsQueryVariables = Exact<{

  groupSearch: Scalars['String'];

  selectedGroupIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type AuthGraphUserGroupsOptionsQueryUser = {
	__typename?: 'User',
	userId: string 
}

export type AuthGraphUserGroupsOptionsQueryUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	user: AuthGraphUserGroupsOptionsQueryUser 
}

export type AuthGraphUserGroupsOptionsQueryItems = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	value: string,
	label: string,
	userGroupAccess?: Array<AuthGraphUserGroupsOptionsQueryUserGroupAccess | null> | null 
}

export type AuthGraphUserGroupsOptionsQueryUserGroups = {
	__typename?: 'UserGroupsCursored',
	items?: Array<AuthGraphUserGroupsOptionsQueryItems> | null 
}

export type AuthGraphUserGroupsOptionsQuery = {
	__typename?: 'Query',
	userGroups?: AuthGraphUserGroupsOptionsQueryUserGroups | null 
};

export type AuthGraphUserGroupsThatHaveAccessQueryVariables = Exact<{

  selectedGroupIds: Array<Scalars['ID']> | Scalars['ID'];

}>;

export type AuthGraphUserGroupsThatHaveAccessQueryUser = {
	__typename?: 'User',
	userId: string 
}

export type AuthGraphUserGroupsThatHaveAccessQueryUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	user: AuthGraphUserGroupsThatHaveAccessQueryUser 
}

export type AuthGraphUserGroupsThatHaveAccessQueryItems = {
	__typename?: 'UserGroup',
	userGroupId: string,
	userGroupName: string,
	id: string,
	value: string,
	label: string,
	userGroupAccess?: Array<AuthGraphUserGroupsThatHaveAccessQueryUserGroupAccess | null> | null 
}

export type AuthGraphUserGroupsThatHaveAccessQueryUserGroups = {
	__typename?: 'UserGroupsCursored',
	items?: Array<AuthGraphUserGroupsThatHaveAccessQueryItems> | null 
}

export type AuthGraphUserGroupsThatHaveAccessQuery = {
	__typename?: 'Query',
	userGroups?: AuthGraphUserGroupsThatHaveAccessQueryUserGroups | null 
};

export const AuthGraphAddUserToUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphAddUserToUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserToUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupAccessRole"},"value":{"kind":"EnumValue","value":"MEMBER"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessCreatedAt"}}]}}]}}]} as unknown as DocumentNode<AuthGraphAddUserToUserGroupMutation, AuthGraphAddUserToUserGroupMutationVariables>;
export const AuthGraphAdvertiserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphAdvertiser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"advertiserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"advertiserAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"advertiserId"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountId"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountName"},"name":{"kind":"Name","value":"advertiserAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountCreatedAt"},"name":{"kind":"Name","value":"advertiserAccountCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<AuthGraphAdvertiserQuery, AuthGraphAdvertiserQueryVariables>;
export const AuthGraphAccountAccessOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphAccountAccessOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"userGroupId"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupAccessRole"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"OWNER"},{"kind":"EnumValue","value":"ADMIN"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"userId"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupAccessRole"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"OWNER"},{"kind":"EnumValue","value":"ADMIN"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"userGroupAccessRole"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<AuthGraphAccountAccessOptionsQuery, AuthGraphAccountAccessOptionsQueryVariables>;
export const AuthGraphAdvertiserListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphAdvertiserList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"advertiserAccountName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"advertiserAccountId"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountId"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountName"},"name":{"kind":"Name","value":"advertiserAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountCreatedAt"},"name":{"kind":"Name","value":"advertiserAccountCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<AuthGraphAdvertiserListQuery, AuthGraphAdvertiserListQueryVariables>;
export const AuthGraphCreateAdvertiserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphCreateAdvertiser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountOwnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAdvertiserAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"advertiserAccountName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountName"}}},{"kind":"Argument","name":{"kind":"Name","value":"advertiserAccountOwnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountOwnerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountId"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountName"},"name":{"kind":"Name","value":"advertiserAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountCreatedAt"},"name":{"kind":"Name","value":"advertiserAccountCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphCreateAdvertiserMutation, AuthGraphCreateAdvertiserMutationVariables>;
export const AuthGraphCreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphCreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAccountLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAccountLevel"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"userPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"userName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"userAccountLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAccountLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"userCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphCreateUserMutation, AuthGraphCreateUserMutationVariables>;
export const AuthGraphCreateUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphCreateUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountId"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountName"},"name":{"kind":"Name","value":"advertiserAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphCreateUserGroupMutation, AuthGraphCreateUserGroupMutationVariables>;
export const AuthGraphDeleteUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphDeleteUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}}]}]}}]} as unknown as DocumentNode<AuthGraphDeleteUserGroupMutation, AuthGraphDeleteUserGroupMutationVariables>;
export const AuthGraphAdvertiserOwnersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphAdvertiserOwners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"advertiserId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"advertiserAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"advertiserId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<AuthGraphAdvertiserOwnersQuery, AuthGraphAdvertiserOwnersQueryVariables>;
export const AuthGraphGrantAdvertiserAccountAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphGrantAdvertiserAccountAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantAdvertiserAccountAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"advertiserAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphGrantAdvertiserAccountAccessMutation, AuthGraphGrantAdvertiserAccountAccessMutationVariables>;
export const AuthGraphGetUserGroupsAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphGetUserGroupsAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"PRIVATE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphGetUserGroupsAccessQuery, AuthGraphGetUserGroupsAccessQueryVariables>;
export const AuthGraphRevokeAdvertiserAccountAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphRevokeAdvertiserAccountAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeAdvertiserAccountAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"advertiserAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appId"}}}]}]}}]} as unknown as DocumentNode<AuthGraphRevokeAdvertiserAccountAccessMutation, AuthGraphRevokeAdvertiserAccountAccessMutationVariables>;
export const AuthGraphRevokeUserFromGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphRevokeUserFromGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFromUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}}]}]}}]} as unknown as DocumentNode<AuthGraphRevokeUserFromGroupMutation, AuthGraphRevokeUserFromGroupMutationVariables>;
export const AuthGraphSearchOwnerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphSearchOwner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userAccountLevel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"ADVERTISER_ADMIN"}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"userId"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"userCreatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<AuthGraphSearchOwnerQuery, AuthGraphSearchOwnerQueryVariables>;
export const AuthGraphReportSharingOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphReportSharingOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupOwnerEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"privateGroups"},"name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupOwnerEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userGroupOwnerEmail"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PRIVATE"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"publicGroups"},"name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userGroupOwnerEmail"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PUBLIC"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphReportSharingOptionsQuery, AuthGraphReportSharingOptionsQueryVariables>;
export const AuthGraphTransferGroupOwnershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphTransferGroupOwnership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transferUserGroupOwnership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}}]}}]} as unknown as DocumentNode<AuthGraphTransferGroupOwnershipMutation, AuthGraphTransferGroupOwnershipMutationVariables>;
export const AuthGraphUpdateAdvertiserAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphUpdateAdvertiserAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountOwnerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAdvertiserAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"advertiserAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"advertiserAccountName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountName"}}},{"kind":"Argument","name":{"kind":"Name","value":"advertiserAccountOwnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"advertiserAccountOwnerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountId"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountName"},"name":{"kind":"Name","value":"advertiserAccountName"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountCreatedAt"},"name":{"kind":"Name","value":"advertiserAccountCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphUpdateAdvertiserAccountMutation, AuthGraphUpdateAdvertiserAccountMutationVariables>;
export const AuthGraphUpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphUpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userAccountLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserAccountLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"userPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"userName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"userAccountLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userAccountLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"userCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"credentialId"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialId"}},{"kind":"Field","name":{"kind":"Name","value":"credentialName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"userGroupAccessRole"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessCreatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphUpdateUserMutation, AuthGraphUpdateUserMutationVariables>;
export const AuthGraphUpdateUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphUpdateUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountId"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountName"},"name":{"kind":"Name","value":"advertiserAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphUpdateUserGroupMutation, AuthGraphUpdateUserGroupMutationVariables>;
export const AuthGraphUpdateUserRoleInUserGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphUpdateUserRoleInUserGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupAccessRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGroupAccessRole"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserRoleInUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupAccessRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupAccessRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}}]}}]} as unknown as DocumentNode<AuthGraphUpdateUserRoleInUserGroupMutation, AuthGraphUpdateUserRoleInUserGroupMutationVariables>;
export const AuthGraphUserGroupsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphUserGroupsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"PUBLIC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":false}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"userGroupId"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountId"},"name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","alias":{"kind":"Name","value":"agencyAccountName"},"name":{"kind":"Name","value":"advertiserAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<AuthGraphUserGroupsListQuery, AuthGraphUserGroupsListQueryVariables>;
export const AuthGraphUsersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphUsersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"email"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":false}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"userId"}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"userCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialId"}},{"kind":"Field","name":{"kind":"Name","value":"credentialName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"EnumValue","value":"userGroupAccessRole"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}},{"kind":"Field","name":{"kind":"Name","value":"userGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupType"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"advertiserAccountName"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]} as unknown as DocumentNode<AuthGraphUsersListQuery, AuthGraphUsersListQueryVariables>;
export const AuthGraphSpotifyReportDataSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphSpotifyReportDataSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"userGroupName"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupType"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PUBLIC"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphSpotifyReportDataSourcesQuery, AuthGraphSpotifyReportDataSourcesQueryVariables>;
export const AuthGraphSpotifyReportExistingGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphSpotifyReportExistingGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":false}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphSpotifyReportExistingGroupsQuery, AuthGraphSpotifyReportExistingGroupsQueryVariables>;
export const AuthGraphUserGroupsOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphUserGroupsOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"groupSearch"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PUBLIC"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphUserGroupsOptionsQuery, AuthGraphUserGroupsOptionsQueryVariables>;
export const AuthGraphUserGroupsThatHaveAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphUserGroupsThatHaveAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedGroupIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PUBLIC"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphUserGroupsThatHaveAccessQuery, AuthGraphUserGroupsThatHaveAccessQueryVariables>;